import { MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import styles from './SelectEditor.module.css';
import { useTranslation } from 'react-i18next';
const SelectEditor = ({ option, setOption }) => {
  const [currentOption, setCurrentOption] = useState(option.value === '' ? -1 : option.value.split('=')[1]);
  const { t } = useTranslation();
  const selectProps = {
    required: true,
    variant: 'outlined',
    fullWidth: true,
    className: styles.select
  };

  return (
    <div className={styles.mainContainer}>
      {option.values.length > 0 ? (
        <Select
          {...selectProps}
          onChange={(e) => {
            setOption({ ...option, value: `${option.name}=${e.target.value}` });
            setCurrentOption(e.target.value);
          }}
          value={currentOption}>
          <MenuItem key={`default_template_option`} value={-1} disabled>
            {t('chartQueryBuilder.queryParam.selectEditor')}
          </MenuItem>
          {option.values?.map((value, idx) => (
            <MenuItem key={`${option.name}_option_${value}`} value={value}>
              {option.displayedValues[idx]}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <Select {...selectProps} defaultValue={-1}>
          <MenuItem key={`no_items`} value={-1} disabled>
            {t('chartQueryBuilder.queryParam.selectEditorNoItems')}
          </MenuItem>
        </Select>
      )}
    </div>
  );
};

export default SelectEditor;
